namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	import Tween = Roodik.Core.Tween.Tween;
	import Easing = Roodik.Core.Tween.Easing;
	import ISoundManager = Roodik.Core.ISoundManager;
	import LocalizationManager = Roodik.Core.LocalizationManager;
	import IAnalytics = Roodik.Core.IAnalytics;

	export class NoMoreMovesPanelView extends ViewBase
	{
		private _closeBtn:SimpleButton;
		private _message : PIXI.Text;
		private _piastresTitle : PIXI.Text;
		private _piastresCount : PIXI.Text;

		constructor(private _localizationManager:LocalizationManager,
		            private _totalScore:number,
		            private _soundManager:ISoundManager,
		            private _analytics:IAnalytics,
		            private _tryAgain:()=>void)
		{
			super("NoMoreMovesView");

			this._analytics.sendEvent("Game","NoMoreMoves","");

			this.createCloseButton();
			this.createMessage();
			this.createPiastres();
			this.totalScore();

			this.show();
		}

		private createPiastres()
		{
			this._piastresTitle = new PIXI.Text(this._localizationManager.getString(LocalizationKey.FOUND_PIASTRES),
			this.titleStyle(36, ['#FFA500', '#FFD700'], '#8B0000'));
			this._piastresTitle.x = -this._piastresTitle.width*0.5;
			this._piastresTitle.y = -70;
			this.addChild(this._piastresTitle);
		}

		private totalScore()
		{
			this._piastresCount = new PIXI.Text(this._totalScore.toString(), {
				fontFamily: 'WellWait',
				fontSize: 60,
				fill: '#ffffff',//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 1,
				align:"center",
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			});
			this._piastresCount.x = -this._piastresCount.width*0.5;
			this._piastresCount.y = -10;
			this.addChild(this._piastresCount);
		}

		private createMessage()
		{
			this._message = new PIXI.Text(this._localizationManager.getString(LocalizationKey.NO_MORE_MOVES),
			{
				fontFamily: 'WellWait',
				fontSize: 60,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: ['#FFA500', '#FFD700'],//'#FFD700',//['#FFD700', '#4a1850'], // gradient
				stroke: '#ffffff',//'#338d13',
				strokeThickness: 5,
				wordWrap: true,
				wordWrapWidth:550,
				dropShadow: true,
				dropShadowColor: '#ffffff',
				dropShadowBlur: 1,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,
				padding:20,
				align : 'center'
			});
			this._message.x = -this._message.width*0.5 - 10;
			this._message.y = -280;
			this.addChild(this._message);
		}

		private titleStyle(fontSize:number, fillColor:any, strokeColor:string)
		{
			return {
				fontFamily: 'WellWait',
				fontSize: fontSize,
				fontStyle: 'italic',
				fontWeight: 'bold',
				fill: ['#FFA500', '#FFD700'],//'#FFD700',//['#FFD700', '#4a1850'], // gradient
				stroke: strokeColor,//'#ffffff',//'#338d13',
				strokeThickness: 5,

				dropShadow: true,
				dropShadowColor: strokeColor,//'#ffffff',
				dropShadowBlur: 1,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			}
		}

		private createCloseButton()
		{
			this._closeBtn = new SimpleButton(this.childByName("TryAgain").display,
			this._localizationManager.getString(LocalizationKey.BUTTON_TRY_AGAIN), this.getButtonTextStyle());
			this._closeBtn.events.on(SimpleButton.CLICKED, this.clickClose.bind(this));
		}

		private clickClose()
		{
			this.hide();
		}

		private show()
		{
			this._soundManager.playSound("no_moves_left.mp3", 1);


			this.alpha = 0;
			this.y = 300;
			let properties = {alpha:this.alpha, y:this.y};
			new Tween(properties)
			.to({alpha: 1, y: 0}, 150)
			.easing(Easing.Quadratic.In)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.start();
		}

		private hide()
		{
			this._soundManager.playSound("click.mp3", 1);

			let properties = {alpha:this.alpha,y:this.y};
			new Tween(properties)
			.to({alpha: 0, y: -300}, 150)
			.easing(Easing.Quadratic.Out)
			.onUpdate(()=>{
				this.alpha = properties.alpha;
				this.y = properties.y;
			})
			.onComplete(function ()
			{
				this._tryAgain();
			}.bind(this))
			.start();
		}

		private getButtonTextStyle()
		{
			return {
				fontFamily: 'WellWait',
				fontSize: 30,
				fill: '#FFDEAD',//['#ffffff', '#4a1850'], // gradient
				stroke: '#000000',
				strokeThickness: 1,
				align:"center",
				dropShadow: true,
				dropShadowColor: '#000000',
				dropShadowBlur: 2,
				dropShadowAngle: Math.PI / 4,
				dropShadowDistance: 1,

				padding:20
			}
		}

		public destroy()
		{
			this.removeChild(this._piastresTitle);
			this.removeChild(this._piastresCount);
			this.removeChild(this._message);
			this._piastresCount.destroy();
			this._message.destroy();
			this._piastresTitle.destroy();

			this._closeBtn.events.off(SimpleButton.CLICKED, this.clickClose.bind(this));
			this._closeBtn.destroy();

			this._tryAgain = null;

			super.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/NoMoreMovesPanelView.ts